module.exports = __webpack_public_path__ + "static/media/objects_12.e17814af.svg";